// Proxy object to map classnames when css modules are not used
import customDatePickerStylings from "./DayPickerStyle.css";
export default {
  container: customDatePickerStylings.CustomDayPicker,
  wrapper: customDatePickerStylings["CustomDayPicker-wrapper"],
  interactionDisabled:
    customDatePickerStylings["CustomDayPicker--interactionDisabled"],
  months: customDatePickerStylings["CustomDayPicker-Months"],
  month: customDatePickerStylings["CustomDayPicker-Month"],

  navBar: customDatePickerStylings["CustomDayPicker-NavBar"],
  navButton: customDatePickerStylings["CustomDayPicker-NavButton"],
  navButtonPrev: customDatePickerStylings["CustomDayPicker-NavButton--prev"],
  navButtonNext: customDatePickerStylings["CustomDayPicker-NavButton--next"],
  navButtonInteractionDisabled:
    customDatePickerStylings["CustomDayPicker-NavButton--interactionDisabled"],

  caption: customDatePickerStylings["CustomDayPicker-Caption"],
  weekdays: customDatePickerStylings["CustomDayPicker-Weekdays"],
  weekdaysRow: customDatePickerStylings["CustomDayPicker-WeekdaysRow"],
  weekday: customDatePickerStylings["CustomDayPicker-Weekday"],
  body: customDatePickerStylings["CustomDayPicker-Body"],
  week: customDatePickerStylings["CustomDayPicker-Week"],
  weekNumber: customDatePickerStylings["CustomDayPicker-WeekNumber"],
  day: customDatePickerStylings["CustomDayPicker-Day"],
  footer: customDatePickerStylings["CustomDayPicker-Footer"],
  todayButton: customDatePickerStylings["CustomDayPicker-TodayButton"],

  // default modifiers
  today: customDatePickerStylings.today,
  selected: customDatePickerStylings.selected,
  disabled: customDatePickerStylings.disabled,
  outside: customDatePickerStylings.outside,

  available: customDatePickerStylings.available,
  unavailable: customDatePickerStylings.unavailable
};



// WEBPACK FOOTER //
// ./components/DayPickerStyleProxy.js